/**
 * FollowUpLayout — Issue #333
 *
 * 随访模块侧边导航：随访计划 / 节点执行 / 疗效事件 / 随访报告。
 */
import { useLocation } from 'wouter';
import type { ReactNode } from 'react';

const NAV_ITEMS = [
  { path: '/follow-up/plans', label: '随访计划' },
  { path: '/follow-up/visits', label: '随访节点' },
  { path: '/follow-up/outcome-incidents', label: '疗效事件' },
  { path: '/follow-up/reports', label: '随访报告' },
];

export default function FollowUpLayout({ children }: { children: ReactNode }) {
  const [location, navigate] = useLocation();
  return (
    <div className="flex min-h-full gap-6">
      <nav className="w-44 shrink-0">
        <ul className="space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive = location.startsWith(item.path);
            return (
              <li key={item.path}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
